import script from "./summary-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./summary-page.vue?vue&type=script&setup=true&lang=ts"

import "./summary-page.vue?vue&type=style&index=0&id=3f30a3da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f30a3da"]])

export default __exports__